/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GetReservationFeatures200Response,
} from '../models/index';
import {
    GetReservationFeatures200ResponseFromJSON,
    GetReservationFeatures200ResponseToJSON,
} from '../models/index';

/**
 * 
 */
export class InternalBillingApi extends runtime.BaseAPI {

    /**
     */
    async getReservationsFeaturesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetReservationFeatures200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/internal-billing/reservations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetReservationFeatures200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getReservationsFeatures(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetReservationFeatures200Response> {
        const response = await this.getReservationsFeaturesRaw(initOverrides);
        return await response.value();
    }

}
